<template>
  <section class="jsk-block pt-0" id="services">
    <div class="container">
      <div class="row text-center">
        <div class="col-12">
          <h6 class="text-uppercase text-title">{{ $t("services.title") }}</h6>
          <h1>{{ $t("services.subtitle") }}</h1>
        </div>
      </div>

      <div class="row mt-5">
        <!-- courses -->
        <div class="col-12 col-lg-4 col-md-4 text-center">
          <img src="./../assets/images/services/kids-courses.png" class="w-75">
          <router-link
            to="/courses"
            class="btn btn-lg btn-secondary text-uppercase mt-5"
          >{{ $t("nav.coursesBtn") }}
           </router-link>
          <p class="mt-3">{{ $t("services.coursesDescr") }}</p>
        </div>
        
        <!-- books -->
      <div class="col-12 col-lg-4 col-md-4 text-center">
          <img src="./../assets/images/services/private-schools.png" class="w-75">
          <router-link
            to="/private-schools"
            class="btn btn-secondary text-uppercase mt-5 btn-lg"
          >{{ $t("nav.privateSchoolsBtn") }}
           </router-link>
          <p class="mt-3">{{ $t("services.privateSchoolsDesc") }}</p>
        </div>

        <!-- game -->
        <div class="col-12 col-lg-4 col-md-4 text-center">
          <img src="./../assets/images/services/teachers.png" class="w-75">
          <router-link
            to="/teachers"
            class="btn btn-secondary text-uppercase mt-5 btn-lg"
          >{{ $t("nav.teachersBtn") }}
           </router-link>
          <p class="mt-3">{{ $t("services.teachersDescr") }}</p>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: "services"
};
</script>